import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Route, Switch } from 'react-router';
import { Experience } from '../experience';
import { ROUTES } from '../routes';
import { KioskHome } from './kioskHome';
import { renderWhenNotNil } from '../../shared/utils/rendering';

export class Kiosk extends PureComponent {
  static propTypes = {
    setKioskMode: PropTypes.func.isRequired,
    fetchKiosk: PropTypes.func.isRequired,
    setKioskBySlug: PropTypes.func.isRequired,
    match: PropTypes.object,
    activeKioskId: PropTypes.string,
  };

  componentDidMount() {
    this.props.setKioskMode(true);
    this.props.fetchKiosk(this.props.match.params.kioskSlug);
  }

  componentWillUnmount() {
    this.props.setKioskMode(false);
    this.props.setKioskBySlug(null);
  }

  renderContent = () => {
    return (
      <Switch>
        <Route path={ROUTES.kioskExperience()} component={Experience} />
        <Route component={KioskHome} />
      </Switch>
    );
  };

  render = () => renderWhenNotNil(this.renderContent)(this.props.activeKioskId);
}
